// helpers.ts — Pure utility functions for P930H Company Calendar form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format date for display (YYYY/MM/DD) */
export const formatDate = (v: string | null | undefined): string => {
  if (!v) return '';
  const d = v.substring(0, 10);
  return d.replace(/-/g, '/');
};

/** Get day of week name in Chinese */
export const getDayName = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '';
  const d = new Date(dateStr.substring(0, 10));
  const days = ['日', '一', '二', '三', '四', '五', '六'];
  return days[d.getDay()] || '';
};

/** Get event type label */
export const getEventTypeLabel = (type: number): string => {
  switch (type) {
    case 1: return '假日';
    case 2: return '活動';
    case 3: return '會議';
    default: return String(type || '');
  }
};

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, mode: string): boolean => {
  if (!isEditing) return true;
  // Date (PK) is readonly in edit mode
  if (key === 'f90h_01' && mode === 'edit') return true;
  // Audit fields always readonly
  if (['f90h_91', 'f90h_92', 'f90h_93'].includes(key)) return true;
  return false;
};
